module.exports = "<div class=js-datetimepicker></div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/dateTime/templates/datePanel.hbs
// module id = 658
// module chunks = 0